import React from 'react';
import MergeOverlapDialog from './MergeOverlapDialog';

export default class MergeOverlapButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            loadedRoutes: null,
        };
    }
    render() {
        return (
            <React.Fragment>
                <a onClick={() => { this.checkForOverlappingRoutes(); }}>
                    Check for overlapping routes
                </a>
                <MergeOverlapDialog
                    onRequestClose={() => this.toggleState()}
                    open={this.state.dialogOpen}
                    loadedRoutes={this.state.loadedRoutes}
                    regionType={this.props.regionType}
                    regionId={this.props.regionId}
                    title={this.props.title}
                />
            </React.Fragment>
        );
    }

    toggleState() {
        this.setState({dialogOpen: !this.state.dialogOpen});
    }

    setRoutes(loadedRoutes) {
        this.setState({loadedRoutes});
    }

    checkForOverlappingRoutes() {
        const url = `/api/trip/hike/${this.props.regionId}/overlapping-routes`;
        fetch(url,
            {
                method: 'GET',
                credentials: 'same-origin'
            }
        )
            .then(response => {
                return response.json();
            })
            .then(myJson => {
                return myJson.overlapping_routes;
            })
            .then(routes => this.setRoutes(routes));
        this.setState({dialogOpen: true});
    }
}
